import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_003",
  "use": "icon-su_003-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_003\"><defs><style>#icon-su_003 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_003_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_003_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"21 24 3 24 3 9 9 9 9 11 5 11 5 22 19 22 19 11 15 11 15 9 21 9 21 24\" /><polygon class=\"cls-2\" points=\"17 5 12 0 7 5 8.41 6.41 11 3.83 11 16 13 16 13 3.83 15.59 6.41 17 5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol